import React from "react";

const TermsConditions = () => {
  return (
    <>
      <div className="container top-spacing" id="terms-conditions">
        <div className="row">
          <h2>Terms & Conditions</h2>
          <div className="terms-conditions-spacing">
            <h1>1. Introduction</h1>
            <p>
              These terms and conditions govern your use of Harry Boone website
              (www.harryboone.com); by using our website, you accept these terms
              and conditions in full. If you disagree with any part of these
              terms and conditions, do not use our website
            </p>
          </div>
          <div className="terms-conditions-spacing">
            <h1>2. Intellectual Property Rights</h1>
            <p>
              Unless otherwise stated, we, Harry Boone own the intellectual
              property rights in the website and/or material on the website.
              Subject to the licence below, all these intellectual property
              rights are reserved.
            </p>
          </div>
          <div className="terms-conditions-spacing">
            <h1>3. Licence To Use Website</h1>
            <p>
              You may view, download for caching purposes only and print pages
              from the website for your own personal use, subject to the
              restrictions below. You must not:
            </p>
            <ul>
              <li>
                Republish material from this website (including republication on
                another website);
              </li>
              <li>
                Sell, rent or otherwise sub-license material on the website;
              </li>
              <li>
                Reproduce, duplicate, copy or otherwise exploit material on our
                website for a commercial purpose;
              </li>
              <li>Edit or otherwise modify any material on the website;</li>
              <li>
                Redistribute material from this website except for content
                specifically and expressly made available for redistribution.
                Where content is specifically made available for redistribution,
                it may only be redistributed within your business or to your
                clients for presentation only.
              </li>
            </ul>
          </div>
          <div className="terms-conditions-spacing">
            <h1>4. Limitations Of Liability</h1>
            <p>
              The information on this website is provided free-of-charge and you
              acknowledge that it would be unreasonable to hold us liable in
              respect of this website and the information on this website.
              Whilst we endeavour to ensure that the information on this website
              is correct, we do not warrant its completeness or accuracy; nor do
              we commit to ensuring that the website remains available or that
              the material on the website is kept up-to-date.
              <br></br>
              <br></br>
              To the maximum extent permitted by applicable law we exclude all
              representations, warranties and conditions (including, without
              limitation, the conditions implied by law of satisfactory quality,
              fitness for purpose and the use of reasonable care and skill).
              <br></br>
              <br></br>
              Our liability is limited and excluded to the maximum extent
              permitted under applicable law. We will not be liable for any
              direct or indirect loss or damage arising under these terms and
              conditions or in connection with our website, whether arising in
              tort, contract, or otherwise. Without limiting the generality of
              the foregoing exclusion, we will not be liable for any loss of
              profit, contracts, business, goodwill, data, income, revenue or
              anticipated savings arising under terms and conditions or in
              connection with our website, whether direct or indirect, and
              whether arising in tort, contract or otherwise.
              <br></br>
              <br></br>
              However, nothing in these terms and conditions shall exclude or
              limit our liability for fraud, for death or personal injury caused
              by our negligence, or for any other liability which cannot be
              excluded or limited under applicable law.
            </p>
          </div>
          <div className="terms-conditions-spacing">
            <h1>5. Restricted Access</h1>
            <p>
              We reserve the right to restrict access to areas of our website,
              or indeed our whole website, at our discretion. If we provide you
              with a user ID and password to enable you to access restricted
              areas of our website or other content or services, you must ensure
              that that user ID and password is kept confidential. You accept
              responsibility for all activities that occur under your user ID or
              password. We may disable your user ID and password at our sole
              discretion.
            </p>
          </div>
          <div className="terms-conditions-spacing">
            <h1>6. Website Usage</h1>
            <ul>
              <li>
                You must not use our website in any way that causes, or may
                cause, damage to the website or impairment of the availability
                or accessibility of the website.
              </li>
              <li>
                You must not use our website in any way which is unlawful,
                illegal, fraudulent or harmful, or in connection with any
                unlawful, illegal, fraudulent or harmful purpose or activity.
              </li>
              <li>
                You must not use our website for any purposes related to
                marketing without our express written consent.
              </li>
              <li>
                You must not use our website to copy, publish or send mass
                mailings or spam.
              </li>
              <li>
                You must not use our website to copy, publish or send material
                which is illegal or unlawful, or material which could give rise
                to legal action under English and other applicable law.
              </li>
              <li>
                All material you copy, publish or send via our website must not
                be defamatory, obscene, indecent, hateful, discriminatory or
                inflammatory; such material must not infringe any person’s
                intellectual property rights or rights of confidence, impinge
                upon any person’s privacy or constitute incitement to commit a
                crime; further, material must not be misleading, deceptive,
                sexually explicit, threatening, abusive, harassing or menacing.
              </li>
              <li>
                We reserve the right to edit or remove any material posted upon
                our website.
              </li>
              <li>
                We may take such action as we deem appropriate to deal with the
                posting of unsuitable material, including suspending or
                cancelling your account, restricting your access to our website,
                or commencing legal proceedings against you.
              </li>
            </ul>
          </div>
          <div className="terms-conditions-spacing">
            <h1>7. Variation</h1>
            <p>
              We may revise these terms and conditions from time-to-time. Please
              check this page regularly to ensure you are familiar with the
              current version.
            </p>
          </div>
          <div className="terms-conditions-spacing">
            <h1>8. Entire Agreement</h1>
            <p>
              These terms and conditions constitute the entire agreement between
              you and us in relation to your use of our website and supersede
              all previous agreements in respect of your use of this website.
            </p>
          </div>
          <div className="terms-conditions-spacing">
            <h1>9. Law And Jurisdiction</h1>
            <p>
              This notice will be governed by and construed in accordance with
              USA law and any disputes relating to this notice shall be subject
              to the exclusive jurisdiction of the courts of the USA.
            </p>
          </div>
          <p>- Harry Walton Boone</p>
        </div>
      </div>
    </>
  );
};

export default TermsConditions;
